import React from 'react';
import { GiLotusFlower } from 'react-icons/gi';
import { FaInstagram, FaWhatsapp, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

const Footer = () => (
  <footer style={{
    background: '#2C1810', color: '#F5D76E',
    padding: '3rem 2rem 2rem', textAlign: 'center'
  }}>
    <div style={{ marginBottom: '1.5rem' }}>
      <img src="https://res.cloudinary.com/dghkmujye/image/upload/v1778060091/Picsart_26-05-05_11-57-45-870_1_eutaqj.png" alt="Swarn Dhoop" style={{ height: '50px', objectFit: 'contain' }} />
      <h3 style={{ fontFamily: 'Cinzel', fontSize: '1.4rem', letterSpacing: '4px', margin: '0.5rem 0' }}>
        SWARN DHOOP
      </h3>
      <p style={{ color: '#c9a96e', fontSize: '0.95rem' }}>
        पवित्र सुगंध, दिव्य अनुभव
      </p>
    </div>

    {/* Contact Details */}
    <div style={{
      display: 'flex', flexDirection: 'column', gap: '0.6rem',
      alignItems: 'center', marginBottom: '2rem'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#c9a96e' }}>
        <FaMapMarkerAlt color="#D4AF37" size={14} />
        <span style={{ fontFamily: 'Inter', fontSize: '0.85rem' }}>
          DDA Janta Flats, GTB Enclave, North East Delhi - 110093
        </span>
      </div>
      <a href="tel:+918700248228"
        style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#c9a96e', textDecoration: 'none' }}>
        <FaPhone color="#D4AF37" size={14} />
        <span style={{ fontFamily: 'Inter', fontSize: '0.85rem' }}>+91 8700248228</span>
      </a>
      <a href="mailto:swarndhoop@gmail.com"
        style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#c9a96e', textDecoration: 'none' }}>
        <FaEnvelope color="#D4AF37" size={14} />
        <span style={{ fontFamily: 'Inter', fontSize: '0.85rem' }}>swarndhoop@gmail.com</span>
      </a>
    </div>

    <div style={{ display: 'flex', justifyContent: 'center', gap: '1.5rem', marginBottom: '2rem' }}>
      <a href="https://instagram.com/swarndhoop" target="_blank" rel="noreferrer"
        style={{ color: '#F5D76E', transition: 'color 0.3s' }}>
        <FaInstagram size={28} />
      </a>
      <a href="https://wa.me/+918700248228" target="_blank" rel="noreferrer"
        style={{ color: '#F5D76E', transition: 'color 0.3s' }}>
        <FaWhatsapp size={28} />
      </a>
    </div>

    <div style={{ height: '1px', background: 'linear-gradient(to right, transparent, #D4AF37, transparent)', marginBottom: '1.5rem' }} />

    <p style={{ color: '#8B6914', fontSize: '0.85rem', fontFamily: 'Inter' }}>
      © 2024 Swarn Dhoop™ · All Rights Reserved
    </p>
    <p style={{ color: '#5a3e1b', fontSize: '0.75rem', marginTop: '0.3rem', fontFamily: 'Inter' }}>
      <a href="/admin" style={{ color: '#5a3e1b', textDecoration: 'none' }}>Admin</a>
    </p>
  </footer>
);

export default Footer;